import { action, computed, observable } from 'mobx';
import { IOffersServiceCMSConfig, IOffersServiceConfigs } from './IConfig';

export default class Config {
    @observable public config: IOffersServiceConfigs;

    constructor(initialConfig: IOffersServiceConfigs) {
        this.updateConfig(initialConfig);
    }

    @action
    public updateConfig(config: Partial<IOffersServiceConfigs>) {
        this.config = {
            ...this.config,
            ...config
        };
    }

    @computed
    public get brandId() {
        const { buidConfig } = this?.config as IOffersServiceConfigs;
        const brand = buidConfig?.['brand.id'] || this.config?.perlgem?.brand_id || '2';

        return brand?.toString();
    }

    @computed
    public get regionId() {
        const { buidConfig } = this?.config as IOffersServiceConfigs;
        const region = buidConfig?.region?.id || this.config?.perlgem?.region_id || '0';

        return region?.toString();
    }

    @computed
    public get apiAuthToken(): string {
        //@ts-ignore
        const { appConfig } = this?.config as IOffersServiceConfigs;

        return appConfig?.pgApiTokens?.offers || this?.config?.restAuthToken || '';
    }

    @computed
    public get offersConfig(): IOffersServiceCMSConfig {
        return this.config.offersConfig;
    }
}
